import { dataSimples } from '../../../lib/datas'
import type { DetalheDaOs } from '../../../types/ordemDeServico'
import { DOCUMENTO_DA_OS as T } from './textoDaOs'

/** Os dois blocos de assinatura do modelo, cada um com nome e matrícula. */
export function AssinaturasDaOs({ ordem }: { ordem: DetalheDaOs }) {
  return (
    <div className="os-assinaturas">
      <div className="os-assinatura">
        <div className="os-assinatura-linha" />
        <p>{ordem.fiscalRequisitanteNome}</p>
        <p>{T.assinaturas.fiscal}</p>
        <p>{T.assinaturas.matricula(ordem.fiscalRequisitanteMatricula)}</p>
        <p style={{ fontSize: '8.5pt' }}>{T.assinaturas.assinouEm(dataSimples(ordem.fiscalRequisitanteAssinouEm))}</p>
      </div>
      <div className="os-assinatura">
        <div className="os-assinatura-linha" />
        <p>{ordem.gestorNome}</p>
        <p>{T.assinaturas.gestor}</p>
        <p>{T.assinaturas.matricula(ordem.gestorMatricula)}</p>
        <p style={{ fontSize: '8.5pt' }}>{T.assinaturas.assinouEm(dataSimples(ordem.gestorAssinouEm))}</p>
      </div>
    </div>
  )
}

/** O que a folha não traz — dito, e não deixado em branco. */
export function RessalvaDaOs({ projeto }: { projeto: boolean }) {
  return (
    <div className="os-ressalva">
      <p className="os-ressalva-titulo">{T.ressalva.titulo}</p>
      <p>{T.ressalva.preposto}</p>
      <p>{projeto ? T.ressalva.cronograma : T.ressalva.divisao}</p>
      <p>{T.ressalva.conferencia}</p>
    </div>
  )
}
